var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneOFive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 290.066,
    height: 988.389,
    viewBox: "0 0 290.066 988.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.322,
    x2: 0,
    y2: 0.443,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7772b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#8c7656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c73a5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1,
    y1: 0.486,
    x2: 0.011,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab7534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0572db"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b7547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e7575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1,
    y1: 0.544,
    x2: 0,
    y2: 0.535,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#897458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#2772ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571dc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1,
    y1: 0.48,
    x2: 0,
    y2: 0.475,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab7736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#7e745f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406f98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6792c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#87775a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e72c3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(-368.372 -28.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M288-.341,5.379,1.653V108.581H67.085V67.735L288,66.654V-.341m2-2.014v71L69.085,69.725v40.856H3.379V-.333Z",
    transform: "translate(366 906)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M5454.256,571.375c-.577,0-.89-.013-.9-.013l-.958-.04v-71.3l.8-.164a31.015,31.015,0,0,0,7.526-2.968,33.919,33.919,0,0,0,13.114-12.512c6.55-11.107,6.922-26.238,1.108-44.969-.959-2.57-3.836-7.039-8.117-11.257-3.407-3.357-8.794-7.625-15.136-8.925-1.081-.085-2.167-.128-3.229-.128-17.063,0-30.352,10.9-33.067,27.112-1.154,6.89-1.687,28.7-1.542,63.066.109,26,.572,50.243.577,50.485l.02,1.013-1.014.006-156.142.918-.007-1L5256,368.23h66.106V490.21H5353c.019-2.617.058-10.227-.008-20.576a244.486,244.486,0,0,1,1.181-26.292,169.416,169.416,0,0,1,5.747-30.328c7.082-24.122,19.483-41.678,36.861-52.179A92.756,92.756,0,0,1,5422.02,350.4a106.892,106.892,0,0,1,26.233-3.219,108.264,108.264,0,0,1,19.035,1.671,92.156,92.156,0,0,1,16.983,4.685,74.093,74.093,0,0,1,15.627,8.345,78.28,78.28,0,0,1,11,9.3,63.722,63.722,0,0,1,8.639,10.664,76.568,76.568,0,0,1,5.984,8.4,125.543,125.543,0,0,1,11.623,23.974,133.024,133.024,0,0,1,7.677,37.6,140.286,140.286,0,0,1-.626,23.305A154.787,154.787,0,0,1,5539,501.111a119.4,119.4,0,0,1-8.939,22.482,95.672,95.672,0,0,1-11.466,17.118,85.126,85.126,0,0,1-26.4,21,89.566,89.566,0,0,1-24.159,8.238A76.806,76.806,0,0,1,5454.256,571.375Zm.139-69.758v67.757a85.141,85.141,0,0,0,36.89-9.446c22.3-11.405,37.711-31.381,45.8-59.372,10.685-36.985,4.925-66.942-1.789-85.559a123.579,123.579,0,0,0-11.422-23.605,74.425,74.425,0,0,0-5.9-8.295l-.059-.068-.046-.078a62.121,62.121,0,0,0-8.438-10.408,74.561,74.561,0,0,0-25.875-17.138,98.8,98.8,0,0,0-35.3-6.221c-12.923,0-32.165,2.318-50.439,13.362-28.354,17.135-43.162,54.16-42.824,107.075.082,12.869,0,21.512,0,21.6l-.01.99h-34.871V370.23h-62.093l1.264,189.453,153.131-.9c-.088-4.863-.461-26.492-.558-49.5-.147-34.973.381-56.307,1.57-63.407a34.842,34.842,0,0,1,4.028-11.447,33.406,33.406,0,0,1,7.575-9.129,34.146,34.146,0,0,1,10.539-6.032,38.19,38.19,0,0,1,12.9-2.174c1.135,0,2.295.047,3.448.139l.06,0,.059.012c6.849,1.384,12.591,5.915,16.2,9.473a47.849,47.849,0,0,1,5.505,6.478,26.293,26.293,0,0,1,3.092,5.533l.017.051c3.23,10.4,4.6,19.861,4.073,28.125a41.158,41.158,0,0,1-5.378,18.511,34.92,34.92,0,0,1-6.8,8.275,36.984,36.984,0,0,1-7.145,4.992A34.836,34.836,0,0,1,5454.4,501.617Z",
    transform: "translate(-4887.63)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    d: "M2,2V71H71V2H2M0,0H73V73H0Z",
    transform: "translate(584 253)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M5320.651,255.227h-65.935l-.007-.993-1.7-226.042h35.729l.193.086,252.092,111.531.01.64,1.235,79.025-1.446-.67-221.156-102.55Zm-63.949-2h61.935l-.989-140.115,1.432.664,221.143,102.544-1.175-75.2L5288.319,30.192h-33.292Z",
    transform: "translate(-4883.835)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M78,4.021c-21.275,0-40.818,6.879-55.028,19.369A67.451,67.451,0,0,0,5.854,46.56,77.844,77.844,0,0,0-.69,78.017a77.844,77.844,0,0,0,5.448,29.935,69.586,69.586,0,0,0,15.2,23.076,73.415,73.415,0,0,0,12.077,9.808,78.789,78.789,0,0,0,14,7.206,84.61,84.61,0,0,0,15.475,4.443A89.79,89.79,0,0,0,78,154a85.3,85.3,0,0,0,16.188-1.542,81.513,81.513,0,0,0,15.141-4.483A77.553,77.553,0,0,0,123,140.767a73.734,73.734,0,0,0,11.792-9.716,70.332,70.332,0,0,0,15.24-23.313,76.067,76.067,0,0,0,5.268-29.7,79.3,79.3,0,0,0-6.5-30.81,69.307,69.307,0,0,0-16.649-23.261A73.616,73.616,0,0,0,107.758,9.2,85.5,85.5,0,0,0,78,4.021m0-2c43.078,0,78.5,29.256,79.3,75.979S121.078,156,78,156-3.09,126.327-2.689,78,34.922,2.021,78,2.021Z",
    transform: "translate(434.629 656)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M153.177,6.326c-20.558,0-39.8,3.138-57.178,9.328A129.338,129.338,0,0,0,50.5,43.008,124.511,124.511,0,0,0,20.248,87.581C12.915,105.712,9.1,126.31,8.915,148.8c-.183,22.039,3.273,42.512,10.272,60.851a130.433,130.433,0,0,0,29.238,45.729,128.507,128.507,0,0,0,21.407,17.356A137,137,0,0,0,94.784,285.42a152.089,152.089,0,0,0,27.962,7.782,172.825,172.825,0,0,0,30.43,2.647,137.637,137.637,0,0,0,53.777-10.626,131.773,131.773,0,0,0,22.892-12.455,134.144,134.144,0,0,0,19.8-16.492,139.561,139.561,0,0,0,17.91-22.294,146.637,146.637,0,0,0,13.271-25.837A153.935,153.935,0,0,0,289,179.506a161.492,161.492,0,0,0,2.618-30.7,166.79,166.79,0,0,0-2.818-29.084,153.371,153.371,0,0,0-7.629-26.915,142.5,142.5,0,0,0-12.1-24.217A134.427,134.427,0,0,0,252.85,47.595a129.318,129.318,0,0,0-43.519-30.232A142.786,142.786,0,0,0,153.177,6.326m0-2c83.212,0,139.644,63.563,140.445,144.459S236.388,297.85,153.177,297.85,6.141,242.136,6.916,148.785,69.965,4.326,153.177,4.326Z",
    transform: "translate(362.47 584.324)",
    fill: "url(#linear-gradient-6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneOFive);
export default __webpack_public_path__ + "static/media/oneOFive.b581862e1a22611c8800dd7d64a79a85.svg";
export { ForwardRef as ReactComponent };